import { ShellApp } from 'vrlcm-gui-types';
import React from 'react';
import AppCard from './AppCard';
import './AppCards.css';
import { l10n } from 'i18n/i18nUtil';
interface Props {
  apps: ShellApp[];
}

const AppCards: React.FunctionComponent<Props> = props => {
  const { apps } = props;

  const appNavList = apps.map((app, index) => {
    return (
      <AppCard key={index} app={app} absoluteRedirection={app.vmid === 'cms'} />
    );
  });
  return (
    <div className="app-card">
      <h4 aria-level={1} className="app-cards__header">
        {l10n('myServices')}
      </h4>
      <div className="app-cards__content">{appNavList}</div>
    </div>
  );
};

export default AppCards;
